import React, { useEffect, useLayoutEffect, useRef, useState, } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "tss-react/mui";
// eslint-disable-next-line lines-around-comment
// @ts-ignore
import { Drawer, JitsiPortal } from "../../../../toolbox/components/web";
import { showOverflowDrawer } from "../../../../toolbox/functions.web";
import participantsPaneTheme from "../../../components/themes/participantsPaneTheme.json";
import { withPixelLineHeight } from "../../../styles/functions.web";
/**
 * Get a style property from a style declaration as a float.
 *
 * @param {CSSStyleDeclaration} styles - Style declaration.
 * @param {string} name - Property name.
 * @returns {number} Float value.
 */
const getFloatStyleProperty = (styles, name) => parseFloat(styles.getPropertyValue(name));
/**
 * Gets the outer height of an element, including margins.
 *
 * @param {Element} element - Target element.
 * @returns {number} Computed height.
 */
const getComputedOuterHeight = (element) => {
    const computedStyle = getComputedStyle(element);
    return (element.offsetHeight +
        getFloatStyleProperty(computedStyle, "margin-top") +
        getFloatStyleProperty(computedStyle, "margin-bottom"));
};
const MAX_HEIGHT = 400;
const useStyles = makeStyles()((theme) => {
    return {
        contextMenu: {
            backgroundColor: theme.palette.ui01,
            border: `1px solid ${theme.palette.ui04}`,
            borderRadius: `${Number(theme.shape.borderRadius)}px`,
            boxShadow: "0px 4px 25px 4px rgba(20, 20, 20, 0.6)",
            color: theme.palette.text01,
            ...withPixelLineHeight(theme.typography.bodyShortRegular),
            marginTop: `${participantsPaneTheme.panePadding * 2 +
                theme.typography.bodyShortRegular.fontSize}px`,
            position: "absolute",
            right: `${participantsPaneTheme.panePadding}px`,
            top: 0,
            zIndex: 2,
            maxHeight: `${MAX_HEIGHT}px`,
            overflowY: "auto",
            padding: `${theme.spacing(2)} 0`,
        },
        contextMenuHidden: {
            pointerEvents: "none",
            visibility: "hidden",
        },
        drawer: {
            paddingTop: "16px",
            "& > div": {
                ...withPixelLineHeight(theme.typography.bodyShortRegularLarge),
                "& svg": {
                    fill: theme.palette.icon01,
                },
            },
        },
    };
});
const ContextMenu = ({ accessibilityLabel, children, className, entity, hidden, inDrawer, isDrawerOpen, offsetTarget, onClick, onKeyDown, onDrawerClose, onMouseEnter, onMouseLeave, isParticipantWaiting = false, // CUSTOM
 }) => {
    const [isHidden, setIsHidden] = useState(true);
    const containerRef = useRef(null);
    const { classes: styles, cx } = useStyles();
    const _overflowDrawer = useSelector(showOverflowDrawer);
    useLayoutEffect(() => {
        if (_overflowDrawer) {
            return;
        }
        if (entity &&
            offsetTarget &&
            containerRef.current &&
            offsetTarget?.offsetParent &&
            offsetTarget.offsetParent instanceof HTMLElement) {
            const { current: container } = containerRef;
            const { offsetTop, offsetParent: { offsetHeight, scrollTop }, } = offsetTarget;
            const outerHeight = getComputedOuterHeight(container);
            const height = Math.min(MAX_HEIGHT, outerHeight);
            container.style.top =
                offsetTop + height > offsetHeight + scrollTop
                    ? `${offsetTop - outerHeight}`
                    : `${offsetTop}`;
            setIsHidden(false);
        }
        else {
            hidden === undefined && setIsHidden(true);
        }
    }, [entity, offsetTarget, _overflowDrawer]);
    useEffect(() => {
        if (hidden !== undefined) {
            setIsHidden(hidden);
        }
    }, [hidden]);
    if (_overflowDrawer && inDrawer) {
        return (React.createElement("div", { className: styles.drawer, onClick: onDrawerClose }, children));
    }
    return _overflowDrawer && !isParticipantWaiting ? (
    // CUSTOM
    // ? <JitsiPortal>
    React.createElement(JitsiPortal, { className: "meeting-partiicpant-overflow" },
        React.createElement(Drawer, { isOpen: isDrawerOpen && _overflowDrawer, onClose: onDrawerClose },
            React.createElement("div", { className: styles.drawer, onClick: onDrawerClose }, children)))) : (React.createElement("div", { "aria-label": accessibilityLabel, className: cx(participantsPaneTheme.ignoredChildClassName, styles.contextMenu, isHidden && styles.contextMenuHidden, className), onClick: onClick, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, ref: containerRef }, children));
};
export default ContextMenu;
